import styled from 'styled-components';

export const LineHeader = styled.div`
  width: 100%;
  border: 1px solid #c9cdd6;
  margin: 1.6rem 0;
`;
